import styled, { css } from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { borderValue } from 'styles/mixins';
import Box from 'components/Box';
export var BADGE_SIZE_LARGE = 90;
export var BADGE_SIZE_SMALL = 70;
export var Section = styled(Box).withConfig({
  displayName: "Layout__Section",
  componentId: "sc-122gtji-0"
})(["padding:", " ", ";@media (min-width:", "){padding:", " ", ";}& + &{padding-top:0;}"], function (p) {
  return p.theme.globals.spacing.s;
}, function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.breakpoints.s;
}, function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.spacing.l;
});
export var SidebarWrapper = styled.div.withConfig({
  displayName: "Layout__SidebarWrapper",
  componentId: "sc-122gtji-1"
})(["@media (min-width:", "){display:flex;align-items:flex-start;}"], function (p) {
  return p.theme.globals.breakpoints.xs;
});
export var Sidebar = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'makeSpaceForBadge';
  }
}).withConfig({
  displayName: "Layout__Sidebar",
  componentId: "sc-122gtji-2"
})(["display:flex;flex-wrap:wrap;gap:", ";border-left:", ";padding-left:", ";@media (min-width:", "){flex-direction:column;gap:", ";min-width:", ";margin-left:", ";padding-left:", ";", "}"], function (p) {
  return p.theme.globals.spacing.xxs;
}, function (p) {
  return borderValue(p.theme);
}, function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return p.theme.globals.breakpoints.xs;
}, function (p) {
  return p.theme.globals.spacing.xxxs;
}, pxToRem(260), function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return p.makeSpaceForBadge && css(["margin-top:", ";"], function (p) {
    return p.theme.globals.spacing.l;
  });
});
export var PlaylistBannerBadge = styled(Box).withConfig({
  displayName: "Layout__PlaylistBannerBadge",
  componentId: "sc-122gtji-3"
})(["position:absolute;z-index:", ";top:", ";right:", ";@media (min-width:", "){top:", ";right:", ";}"], function (p) {
  return p.theme.globals.z.raised;
}, pxToRem(BADGE_SIZE_SMALL * -0.5 - 2), function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return p.theme.globals.breakpoints.xs;
}, pxToRem(BADGE_SIZE_LARGE * -0.5 - 2), function (p) {
  return p.theme.globals.spacing.xxl;
});